export default class User {
    /**
     * 用户ID
     */
    public userId:string;
    /**
     * 用户登录名（大概率与userCode一致）
     */
    public username:string;
    /**
     * 真实姓名(需考虑少数民族的名称超长)
     */
    public fullName:string;
    /**
     * 用户头像（非证件照)
     */
    public avatar:string;
    /**
     * 用户编号（学生学号，教师教工号）
     */
    public no:string;
    constructor({userId='',username='',fullName='',avatar='',no=''}={}){
        this.userId=userId;
        this.username=username;
        this.fullName=fullName;
        this.avatar=avatar;
        this.no=no;
    }
}